import { useEffect } from "react";
import { toast } from "sonner";

type Flash = {
  notice?: string;
  alert?: string;
};

export function useFlashToast(flash?: Flash) {
  useEffect(() => {
    if (flash?.notice) toast.success(flash.notice);
    if (flash?.alert) toast.error(flash.alert);
  }, [flash]);
}
